import { useMemo } from 'react'
import { Dropdown } from 'components/common'
import {
  FilterDateInput,
  FilterTextInput,
} from 'components/common/logFilterInputs'
import useLogFilters from 'hooks/useLogFilters'
import { buildEnumOptions, FilterMeta } from 'utils/helpers'

type Props = {
  filterMeta?: FilterMeta
}

export const FILTER_FIELD_POWER_BI_SYNC_LOG = 'powerBiSyncFilters'

const PowerBiSyncLogFilterForm = ({ filterMeta }: Props) => {
  const { filters, setField } = useLogFilters(FILTER_FIELD_POWER_BI_SYNC_LOG)

  const recordTypeOptions = useMemo(
    () => buildEnumOptions(filterMeta, 'recordType', ['ORDER', 'RMA']),
    [filterMeta],
  )

  const statusOptions = useMemo(
    () => buildEnumOptions(filterMeta, 'status', ['SUCCESS', 'FAILED']),
    [filterMeta],
  )

  const eventTypeOptions = useMemo(
    () => buildEnumOptions(filterMeta, 'eventType', ['CREATED', 'CANCELED']),
    [filterMeta],
  )

  return (
    <div className="mb-6 flex flex-wrap items-end gap-4 rounded-xl border border-gray-200 bg-white px-5 py-4 shadow-sm">
      <div className="min-w-[200px]">
        <Dropdown
          name="recordType"
          label="Type"
          options={recordTypeOptions}
          defaultValue={filters.recordType || ''}
          setValue={(_field: string, value: string) =>
            setField('recordType', value)
          }
        />
      </div>

      <div className="min-w-[200px]">
        <Dropdown
          name="status"
          label="Status"
          options={statusOptions}
          defaultValue={filters.status || ''}
          setValue={(_field: string, value: string) =>
            setField('status', value)
          }
        />
      </div>

      <div className="min-w-[200px]">
        <Dropdown
          name="eventType"
          label="Event Type"
          options={eventTypeOptions}
          defaultValue={filters.eventType || ''}
          setValue={(_field: string, value: string) =>
            setField('eventType', value)
          }
        />
      </div>

      <FilterTextInput
        label="Order No"
        value={filters.orderNo || ''}
        onApply={(value) => setField('orderNo', value)}
      />

      <FilterTextInput
        label="RMA No"
        value={filters.rmaNo || ''}
        onApply={(value) => setField('rmaNo', value)}
      />

      <FilterDateInput
        label="Start Date"
        value={filters.startDate || ''}
        onChange={(value) => setField('startDate', value)}
      />

      <FilterDateInput
        label="End Date"
        value={filters.endDate || ''}
        onChange={(value) => setField('endDate', value)}
      />
    </div>
  )
}

export default PowerBiSyncLogFilterForm
